import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TerminationReasonType } from '@/domain/contract/types/messages'

type TerminationReasonProps = {
  reason: TerminationReasonType
}

export const TerminationReason: FC<TerminationReasonProps> = ({ reason }) => {
  const { t } = useTranslation()

  switch (reason) {
    case TerminationReasonType.INITIAL_MIGRATION:
      return t('contract.messagesFlyout.notRecorded')
    case TerminationReasonType.BAD_PAYMENT:
      return t('contract.messagesFlyout.terminationReasons.BAD_PAYMENT')
    case TerminationReasonType.PRICING:
      return t('contract.messagesFlyout.terminationReasons.PRICING')
    case TerminationReasonType.QUALITY_OF_SERVICE:
      return t('contract.messagesFlyout.terminationReasons.QUALITY_OF_SERVICE')
    case TerminationReasonType.NOT_NEEDED_ANYMORE:
      return t('contract.messagesFlyout.terminationReasons.NOT_NEEDED_ANYMORE')
    case TerminationReasonType.REVOCATION_OF_CONSENT:
      return t('contract.messagesFlyout.terminationReasons.REVOCATION_OF_CONSENT')
    case TerminationReasonType.OBJECTION_TO_TARIFF_CHANGE:
      return t('contract.messagesFlyout.terminationReasons.OBJECTION_TO_TARIFF_CHANGE')
    case TerminationReasonType.EXTRAORDINARY:
      return t('contract.messagesFlyout.terminationReasons.EXTRAORDINARY')
    case TerminationReasonType.EXTRAORDINARY_SUBSTITUTE:
      return t('contract.messagesFlyout.terminationReasons.EXTRAORDINARY_SUBSTITUTE')
    case TerminationReasonType.OTHER:
      return t('contract.messagesFlyout.terminationReasons.OTHER')
    case TerminationReasonType.ORDINARY:
      return t('contract.messagesFlyout.terminationReasons.ORDINARY')
    case TerminationReasonType.CONTRACT_REVOCATION:
      return t('contract.messagesFlyout.terminationReasons.CONTRACT_REVOCATION')
    case TerminationReasonType.CONTRACT_REVOCATION_SUBSTITUTE:
      return t('contract.messagesFlyout.terminationReasons.CONTRACT_REVOCATION_SUBSTITUTE')
  }
}
